import React, { useEffect, useState } from "react";
import "./Our_Centers.css";
import Common_Title_1 from "../../common/common_components/common_title_1/Common_Title_1";
import { AllCenters } from "../../../features/admin/common/Slice";
import { useDispatch, useSelector } from "react-redux";

const Our_Centers = () => {
  const dispatch = useDispatch();

  const all_centers = useSelector((state) => state.common.all_centers || []);

  useEffect(() => {
    dispatch(AllCenters());
  }, [dispatch]);

  // Prepare dynamic locations based on API response
 const locations =
  all_centers?.map((item) => {
    return [
      item?.address,
      item?.Area?.name,
      item?.City?.name,
      item?.State?.name,
      item?.Pincode?.name,
      item?.Country?.name,
    ]
      .filter(Boolean) // removes undefined / null
      .join(", ");
  }) || [];


  const [visibleCount, setVisibleCount] = useState(8);

  const handleViewMore = () => {
    if (visibleCount >= locations.length) {
      setVisibleCount(8); // Reset
    } else {
      setVisibleCount((prev) => Math.min(prev + 4, locations.length));
    }
  };

  return (
    <section className="Our_Centers">
      <div className="container">
        <div className="main_content_div">
          <Common_Title_1 subText="Our Centres" />

          <div className="location_holder">
            <div className="row">
              {locations.slice(0, visibleCount).map((item, index) => {
                return (
                  <div className="col-lg-3 col-md-4 col-sm-6" key={index}>
                    <div className="location_card">
                      <p className="location_no">Centre {index + 1}</p>
                      <p className="location_text">{item}</p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>

          {locations.length > 8&& (
            <div className="Yellow_Btn_holder text-center mt-3">
              <button className="Yellow_Btn mx-auto" onClick={handleViewMore}>
                {visibleCount >= locations.length ? "View Less" : "View More"}
              </button>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default Our_Centers;













// import React, { useEffect, useState } from "react";
// import "./Our_Centers.css";
// import Common_Title_1 from "../../common/common_components/common_title_1/Common_Title_1";
// import { AllCenters, AllCountry } from "../../../features/admin/common/Slice";
// import { useDispatch, useSelector } from "react-redux";

// const Our_Centers = () => {
// const dispatch = useDispatch();

//   const all_centers = useSelector((state) => state.common.all_centers);

//   console.log("all_centers?.addressall_centers?.addressall_centers?.addressall_centers?.address",all_centers[0]?.address);
  


//   useEffect(() => {
//       dispatch(AllCenters());
//     }, [dispatch])
//   const locations = [
//     "1313 Springvale Dr, Belair , MD 21015, USA",
//     "1314 Springvale Dr, Belair , MD 21015, USA",
//     "1315 Springvale Dr, Belair , MD 21015, USA",
//     "1316 Springvale Dr, Belair , MD 21015, USA",
//     "1317 Springvale Dr, Belair , MD 21015, USA",
//     "1318 Springvale Dr, Belair , MD 21015, USA",
//     "1319 Springvale Dr, Belair , MD 21015, USA",
//     "1320 Springvale Dr, Belair , MD 21015, USA",
//     "1321 Springvale Dr, Belair , MD 21015, USA",
//     "1322 Springvale Dr, Belair , MD 21015, USA",
//     "1323 Springvale Dr, Belair , MD 21015, USA",
//     "1324 Springvale Dr, Belair , MD 21015, USA",
//   ];

//   const [visibleCount, setVisibleCount] = useState(8);

//   const handleViewMore = () => {
//     if (visibleCount >= locations.length) {
//       // Reset back to 8 when no more cards
//       setVisibleCount(8);
//     } else {
//       // Show 4 more cards
//       setVisibleCount((prev) => Math.min(prev + 4, locations.length));
//     }
//   };

//   return (
//     <section className="Our_Centers">
//       <div className="container">
//         <div className="main_content_div">
//           <Common_Title_1 subText="Our Centres" />

//           <div className="location_holder">
//             <div className="row">
//               {locations.slice(0, visibleCount).map((item, index) => {
//                 return (
//                   <div
//                     className="col-lg-3 col-md-4 col-sm-6"
//                     key={index}
//                   >
//                     <div className="location_card">
//                       <p className="location_no">Centre {index + 1}</p>
//                       <p className="location_text">{item}</p>
//                     </div>
//                   </div>
//                 );
//               })}
//             </div>
//           </div>

//           {locations.length > 8 && (
//             <div className="Yellow_Btn_holder text-center mt-3">
//               <button className="Yellow_Btn mx-auto" onClick={handleViewMore}>
//                 {visibleCount >= locations.length ? "View Less" : "View More"}
//               </button>
//             </div>
//           )}
//         </div>
//       </div>
//     </section>
//   );
// };

// export default Our_Centers;
